import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useSelector } from 'react-redux';
import { AppState } from '@/store/configureStore';

export const useLocationCheck = () => {
    const router = useRouter();
    const location = useSelector((state: AppState) => state.location);
    useEffect(() => {
        if (!location?.activeLocation?.id || location?.activeLocation?.id === "") {        
            router.push('/location-select');
        }
    }, [location?.activeLocation?.id, router]);
}; 